export const ReleaseButtonTypes = {
  ADMIN_RELEASE: 'Noudettavaksi',
  INVOICE: 'Laskuta',
  PARTIAL_INVOICE: 'Välilaskutus',
  SCAN_OUT: 'Varastoon',
  ADMIN_HANDLE: 'Käsittele',
}
